import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from '@mui/material';
import { ErrorTypography } from 'components/atoms';
import { BaseFieldProps } from 'components/organisms/forms/form-builder/types';
import { noop } from 'lodash';
import React, { FC, useEffect, useState } from 'react';

import { MultipleInputField } from './MultipleInputField';

export const PatientInstructionsField: FC<BaseFieldProps<string[]>> = (props) => {
  const {
    disabled = false,
    error,
    fieldKey,
    initValue = [],
    label = 'Instructions',
    onChange = noop,
    required = true,
    xs = 12,
  } = props;
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (error) {
      setExpanded(true);
    }
  }, [error]);

  return (
    <Grid item xs={xs}>
      <Accordion
        disableGutters
        expanded={expanded}
        onChange={(_, nextExpanded) => setExpanded(nextExpanded)}
        data-testid={`${fieldKey}-section`}
        slotProps={{ transition: { unmountOnExit: false } }}
      >
        <AccordionSummary
          aria-controls={`${fieldKey}-content`}
          expandIcon={<ExpandMoreIcon />}
          id={`${fieldKey}-header`}
          data-testid={`${fieldKey}-toggle`}
        >
          <Typography>
            {label} {required ? '*' : null}
          </Typography>
        </AccordionSummary>
        <AccordionDetails id={`${fieldKey}-content`}>
          <Grid container>
            <MultipleInputField
              disabled={disabled}
              error={error}
              fieldKey={fieldKey}
              initValue={initValue}
              label={label}
              onChange={onChange}
              required={false}
              type="text"
            />
          </Grid>
          <ErrorTypography>{error}</ErrorTypography>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};
